import { TextElementType } from "@/components/PdfDocument/types/pdfTypes";
import {
    getTextColourStyle,
    getTextStyle,
} from "@/components/PdfDocument/utils/getStyles";
import { GLOBAL_STYLE_KEY } from "@/constants/resume";
import { ResumeStyles } from "@/types/resume";

interface TitleWrapperProps {
    children: React.ReactNode;
    isStaticHeader?: boolean;
    stylesConfig?: ResumeStyles;
    variant: TextElementType;
    id: string;
}

export const TitleWrapper = ({
    children,
    isStaticHeader,
    stylesConfig,
    variant,
    id,
}: TitleWrapperProps) => {
    const underlineSectionHeadings =
        stylesConfig?.[GLOBAL_STYLE_KEY]?.underlineSectionHeadings;
    const shouldUnderline =
        variant === "h2" && !isStaticHeader && underlineSectionHeadings;
    const titleStyle = getTextStyle(
        stylesConfig?.[GLOBAL_STYLE_KEY]?.headingFontSize ?? "",
        variant,
        true,
    );
    const textColourStyle = getTextColourStyle({
        accentColor: stylesConfig?.[GLOBAL_STYLE_KEY]?.themeColor ?? "",
        isStaticHeader,
        fieldKey: id,
    });

    return (
        <div
            style={{
                wordBreak: "break-word",
                borderBottom: shouldUnderline ? "2px solid #21252A" : "",
                ...titleStyle,
                ...textColourStyle,
            }}
        >
            {children}
        </div>
    );
};
